import {createAction, props} from '@ngrx/store';
import {RegionCode} from '../../../services/api/account/regions/region.model';
import {InstanceType} from '../../../services/api/account/instance-types/instance-type.model';


const category = '[ClusterInstanceTypes]';

export const loadClusterInstanceTypes = createAction(
  `${category} Load Cluster Instance Types`,
  props<{ region: RegionCode }>()
);

export const loadClusterInstanceTypesSuccess = createAction(
  `${category} Load Cluster Instance Types Success`,
  props<{ data: InstanceType[] }>()
);

export const loadClusterInstanceTypesFailure = createAction(
  `${category} Load Cluster Instance Types Failure`,
  props<{ error: any }>()
);

export const clearClusterInstanceTypesState = createAction(
  `${category} Clear Cluster Instance Types State`
);
